import axios from 'axios';
import { msalInstance, idTokenRequest } from '../config/authConfig';
import { LOCAL_AUTH_TOKEN_KEY } from '../constants/auth';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: prefer explicit Authorization, then local JWT, then MSAL ID token
apiClient.interceptors.request.use(
  async (config) => {
    const existing = config.headers.Authorization;
    if (existing) {
      return config;
    }

    const localToken = typeof localStorage !== 'undefined' ? localStorage.getItem(LOCAL_AUTH_TOKEN_KEY) : null;
    if (localToken) {
      config.headers.Authorization = `Bearer ${localToken}`;
      return config;
    }

    const accounts = msalInstance.getAllAccounts();
    console.log('API Request - Accounts:', accounts.length);
    console.log('API Request - Using ID token for authentication');

    if (accounts.length > 0) {
      try {
        const idResponse = await msalInstance.acquireTokenSilent({
          ...idTokenRequest,
          account: accounts[0],
        });
        console.log('API Request - ID token acquired:', idResponse.idToken ? 'Yes' : 'No');
        config.headers.Authorization = `Bearer ${idResponse.idToken}`;
      } catch (idError) {
        console.error('Failed to acquire ID token', idError);
        try {
          const popupResponse = await msalInstance.acquireTokenPopup(idTokenRequest);
          console.log('API Request - Popup ID token acquired:', popupResponse.idToken ? 'Yes' : 'No');
          config.headers.Authorization = `Bearer ${popupResponse.idToken}`;
        } catch (popupError) {
          console.error('Failed to acquire token via popup', popupError);
        }
      }
    } else {
      console.log('API Request - No accounts found');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized - redirect to login or refresh token
      console.error('Unauthorized access');
    }
    return Promise.reject(error);
  }
);

export default apiClient;


